import { CanActivateFn } from '@angular/router';
import {
  INVOICE_ROUTE_PARENT_OVERVIEW_PARAM,
  InvoiceRouteParentOverviewParam,
  ROUTE_PARAMS
} from '@app/app.routes-constants';
import { UserDetailsResponse } from '@api-client/mobipay';
import {
  featureAccessCanActivateGuard
} from '@app/shared/features/access-rights/router-utils/guards/feature-access.can-activate.guard';
import FeaturesEnum = UserDetailsResponse.FeaturesEnum;

export const invoiceDetailsCanActivateGuard: CanActivateFn = (route, state) => {
  const parentOverview = route.paramMap.get(ROUTE_PARAMS.INVOICE_ROUTE.PARENT_OVERVIEW) as InvoiceRouteParentOverviewParam;

  const requiredFeature = parentOverview === INVOICE_ROUTE_PARENT_OVERVIEW_PARAM.OUTBOUND ? FeaturesEnum.OutboundInvoices : FeaturesEnum.InboundInvoices;

  return featureAccessCanActivateGuard({
    requiredFeature: requiredFeature,
    options: { skipLocationChange: true }
  })(route, state);
};